
import MButton from "@/components/MButton.vue";
import MIcon from "@/components/MIcon.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MButton,
    MIcon
  },
  emits: ["onModalOpened", "onModalClosed"],
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    conditionModalShowing: {
      type: Boolean,
      default: false
    },
    dropdownDirection: {
      type: String,
      default: "up"
    }
  },
  watch: {
    conditionModalShowing(showing: boolean) {
      if (!showing) return;
      this.forceCloseModal();
    },
    showModal(showing: boolean) {
      if (showing) {
        requestAnimationFrame(() => {
          window.addEventListener("click", this.forceCloseModal);
        });
      } else {
        window.removeEventListener("click", this.forceCloseModal);
      }
    }
  }
})
export default class MActionDropdown extends Vue {
  title!: string;
  disabled = false;
  showModal = false;
  conditionModalShowing = false;
  dropdownDirection: "up" | "down" = "up";

  get dropdownClasses() {
    return this.dropdownDirection === "up"
      ? "absolute left-0 bottom-8 pt-4 z-10"
      : "absolute left-0 top-8 pb-4 z-10";
  }

  changeShowModal() {
    if (this.disabled) {
      return;
    }
    this.showModal = !this.showModal;
    if (this.showModal) {
      this.$emit("onModalOpened");
    } else {
      this.$emit("onModalClosed");
    }
  }

  forceCloseModal() {
    this.showModal = false;
    this.$emit("onModalClosed");
  }

  /** 外部から閉じるためのメソッド */
  close() {
    this.forceCloseModal();
  }

  beforeUnmount(): void {
    window.removeEventListener("click", this.forceCloseModal);
  }
}
